<template>
<div class="SidingPage">
  <h1 class="page-title">Siding Gallery</h1>
  <p class="ImagesNotice">Images of Siding Coming Soon!</p>
</div>
</template>

<script>
export default {
  name: 'SidingPage',
};
</script>

<style scoped>
.SidingPage {
  background-color: #212121;
  display: flex;
  flex-direction: column;
  margin-top: 95px;
  min-height: 50vh;
}

.page-title {
  color: white;
  text-align: center;
  padding: 20px;
  margin: 0;
  font-size: 2em;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.ImagesNotice {
  color: #fff;
  font-size: 20px;
  text-align: center;
  margin-top: 20px;
}
</style>